import React, { Component } from 'react';
import '../style.css';

class HelpView extends Component {

    render() {
        return (
            <div className="full-height">
                <header>
                    <p>Analytics as a Service (A3S) Historical /&nbsp; Help</p>
                </header>

                <div id="background"></div>

                <noscript>
                    For full functionality of this site it is necessary to enable JavaScript. Here are the <a
                        href="http://www.enable-javascript.com/" target="_blank" rel="noopener noreferrer">instructions how to enable JavaScript in your web
            browser</a>.
    </noscript>

                <canvas id="bubbly-layer" style={{ position: "fixed", top: "0", left: "0", zIndex: "-5" }}></canvas>

                <div className="wiz-content">
                    <div className="title">
                        Help
                </div>

                    <ul className="wiz-progress-bar">
                        <li className="active">
                            <span className="txt-start">Start</span>
                        </li>
                        <li className="active">
                            <span className="txt-install">Install</span>
                        </li>
                        <li className="active">
                            <span className="txt-summary">Summary</span>
                        </li>
                    </ul>
                    <main>

                        <div className="installed">
                            <p>
                                <span className="txt-Help-install">
                                    The installation wizard is a three step installation process of A3S premium.
                                </span><br/>
                                <div style={{ textAlign: "left" }}>
                                    <ul style={{ marginLeft: "32%" }}>
                                        <li>Step 1: Validates the integration and checks if the org is enabled for A3S premium</li>
                                        <li>Step 2: User selects the required A3S product for the org</li>
                                        <li>Step 3: Install the app and updated the org details to database</li>
                                    </ul>
                                </div>
                                <span className="txt-Help-install">
                                    The installation wizard creates the required roles and oauth required
                                </span><br/>
                                <span className="txt-Help-install">
                                    The customer details are uploaded to backend with the required installation details
                                </span><br/>
                                <span className="txt-Help-install">
                                    The installation team is notified with the details to complete the installation
                                </span><br/>
                            </p>
                        </div>
                    </main>
                </div>
                <footer style={{ marginTop: "1%" }}>
                </footer>
            </div>
        )
    }
};

export default HelpView;